// @react
import React from 'react'
// @libraries
import DocumentTitle from 'react-document-title'
// @components
import PageTitle from '@bit/atd.web.page-title'
import AccountAccess from 'modules/profile/components/AccountAccess'
import PageWrapper from 'modules/profile/components/PageWrapper'

/**
 * 5.0.2 Profile - Password & Security
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=2507%3A7294
 */

type PropsType = any

const title = 'Profile - Security'

const Security = (props: PropsType) => {
  return (
    <PageWrapper>
      <DocumentTitle title={`${title} | ATD`}>
        <>
          <PageTitle>Login and Security</PageTitle>
          <AccountAccess />
        </>
      </DocumentTitle>
    </PageWrapper>
  )
}

export default Security
